var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDices16Px = function SvgIconDices16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.34 8.493A1.832 1.832 0 0 0 7.508 6.66H2.841a1.833 1.833 0 0 0-1.834 1.833v4.667a1.835 1.835 0 0 0 1.834 1.833h4.666a1.834 1.834 0 0 0 1.834-1.833V8.493Zm-1.833 4a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0Zm-4-.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm1.667-1.666a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333Zm1.667-1.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm-2.667.667a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M5.685 5.993h1.822a2.498 2.498 0 0 1 2.5 2.5v1.728c.55.186.928.307.952.316a1.834 1.834 0 0 0 2.345-1.104l1.58-4.391a1.832 1.832 0 0 0-1.104-2.346l-4.39-1.58A1.831 1.831 0 0 0 7.042 2.22L5.685 5.993Zm6.12 2.192a.667.667 0 1 0-1.256-.452.667.667 0 0 0 1.256.452Zm-1.406-2.986a.666.666 0 1 0-.45 1.254.666.666 0 0 0 .45-1.254Zm-.602-1.28a.667.667 0 1 0-1.256-.45.667.667 0 0 0 1.256.45Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDices16Px;